import React from "react";
import { sf_mucphaithu } from "../../../models/response/thu-phi/sf_mucphaithu";
import { bienLaiThuApi } from "../../../api/bienLaiApi";
import SendEmailModalBase from "./SendEmailModalBase";
import SendThongBaoPhiPrintBtn from "./SendThongBaoPhiPrintBtn";

type SendThongBaoPhiModalProps = {
    onClose: () => void,
    sf_mucphaithu: sf_mucphaithu,
    ts_hocsinh_id: number,
    printDisabled?: boolean,
    buttonText?: string
}

const SendThongBaoPhiModal: React.FC<SendThongBaoPhiModalProps> = (props) => {
    return (
        <SendEmailModalBase
            onClose={props.onClose}
            sf_mucphaithu={props.sf_mucphaithu}
            ts_hocsinh_id={props.ts_hocsinh_id}
            buttonText={props.buttonText}
            title="Gửi thông báo phí đến PHHS"
            sendButtonText="Gửi thông báo phí"
            successMessage="Đã gửi email thông báo phí"
            failedMessage="Không gửi được thông báo phí"
            loadEmailContent={bienLaiThuApi.get_thongbaophi_email_content}
            sendEmail={bienLaiThuApi.send_thongbaophi}
            renderPrintButton={() => (
                !props.sf_mucphaithu.so_chung_tu.includes("RV") ? (
                    <SendThongBaoPhiPrintBtn
                        disabled={props.printDisabled ?? false}
                        sf_mucphaithu={props.sf_mucphaithu}
                        buttonText="In thông báo phí"
                    />
                ) : null
            )}
        />
    );
};

export default SendThongBaoPhiModal;
